export const AdXAdType = Object.freeze({
  adXNative: 'adXNative' as const,
  adXStandard: 'adXStandard' as const
})

export const PrebidAdType = Object.freeze({
  prebidStandard: 'prebidStandard' as const,
  inBannerNative: 'inBannerNative' as const,
  prebidNative: 'prebidNative' as const
})

export const AdType = Object.freeze({
  ...AdXAdType,
  ...PrebidAdType
})

export type IAdType = keyof typeof AdType
